import { render, staticRenderFns } from "./cancel.vue?vue&type=template&id=06e1eb6a&scoped=true&"
import script from "./cancel.vue?vue&type=script&lang=js&"
export * from "./cancel.vue?vue&type=script&lang=js&"
import style0 from "./cancel.vue?vue&type=style&index=0&id=06e1eb6a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e1eb6a",
  null
  
)

export default component.exports